import { css } from '@emotion/react';
import styled from '@emotion/styled';

/**
 * 页面容器额外属性
 */
export interface PageForwardedProps {
  /**
   * 容器内边距
   */
  padding?: number | number[];
}

/**
 * 页面容器
 */
export const Page = styled.section<PageForwardedProps>`
  ${({ padding = 24 }) =>
    css`
      padding: ${typeof padding === 'number'
        ? `${padding}px`
        : padding.map((s) => `${s}px`).join(' ')};
    `}
`;

/**
 * 章节容器额外属性
 */
export interface SectionForwardedProps {
  /**
   * 容器外间距
   */
  span?: number;
}

/**
 * 章节容器
 */
export const Section = styled.section<SectionForwardedProps>`
  &:not(:last-of-type) {
    margin-bottom: ${({ span = 24 }) => `${span}px`};
  }
`;

/**
 * 顶部容器额外属性
 */
export interface HeaderForwardedProps {
  /**
   * 容器高度
   */
  height?: number;
}

/**
 * 顶部容器
 */
export const Header = styled.header<HeaderForwardedProps>`
  flex: 0 0 auto;
  ${({ height }) =>
    height !== undefined &&
    css`
      width: ${height}px;
    `}
`;

/**
 * 侧边容器额外属性
 */
export interface SiderForwardedProps {
  /**
   * 容器宽度
   */
  width?: number;
}

/**
 * 侧边容器
 */
export const Sider = styled.aside<SiderForwardedProps>`
  flex: 0 0 auto;
  ${({ width }) =>
    width !== undefined &&
    css`
      width: ${width}px;
    `}
`;

/**
 * 内容容器
 */
export const Content = styled.main`
  flex: 1 1 auto;
`;

/**
 * 底部容器额外属性
 */
export interface FooterForwardedProps {
  /**
   * 容器高度
   */
  height?: number;
}

/**
 * 底部容器
 */
export const Footer = styled.footer<FooterForwardedProps>`
  flex: 0 0 auto;
  ${({ height }) =>
    height !== undefined &&
    css`
      width: ${height}px;
    `}
`;

/**
 * 布局容器属性
 */
export interface LayoutForwardedProps {
  /**
   * 是否是根布局容器
   */
  root?: boolean;
  /**
   * 布局方向
   */
  direction?: 'row' | 'column';
}

/**
 * 布局容器
 */
const Layout = styled.section<LayoutForwardedProps>`
  display: flex;
  flex-direction: ${({ direction = 'column' }) => direction};
  flex: 1 1 auto;
  overflow: hidden;
  ${({ root }) =>
    root &&
    css`
      width: 100vw;
      height: 100vh;
    `};
`;

export default Layout;
